import { Grid } from '@mui/material'

import { ExperimentGroupingStatus } from '../../../types/emsData'
import { ExpFilterState, FilterAction, filterActionTypes } from '../../../utils/state/managementFilters'
import FormDateTimePicker from '../reusableComponents/formDateTimePicker'
import SearchBar from '../reusableComponents/searchBar'
import SingleSelectDropdown from '../reusableComponents/singleSelectDropdown'

interface Props {
    statusFilterOptions?: ExperimentGroupingStatus[]
    expFiltersState: ExpFilterState
    expFilterDispatch: React.Dispatch<FilterAction>
}

export const ManagementSearch = ({ statusFilterOptions, expFiltersState, expFilterDispatch }: Props) => {
    return (
        <Grid data-test="Filtering-Accordian" container direction="row" sx={{ marginTop: '8px' }} rowGap={'16px'}>
            <Grid item xs={12}>
                <SearchBar
                    label={'Seach by experiment name'}
                    searchTerm={expFiltersState.name}
                    setSearchTerm={(value) =>
                        expFilterDispatch({
                            type: filterActionTypes.setName,
                            payload: value,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <SearchBar
                    label={'Seach by website'}
                    searchTerm={expFiltersState.domain}
                    setSearchTerm={(value) =>
                        expFilterDispatch({
                            type: filterActionTypes.setDomain,
                            payload: value,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <SingleSelectDropdown
                    maxWidth={'292px'}
                    fullWidth
                    state={expFiltersState.status}
                    changeFunction={(value) =>
                        expFilterDispatch({
                            type: filterActionTypes.setStatus,
                            payload: value,
                        })
                    }
                    options={statusFilterOptions ?? []}
                    label={'Filter by status'}
                />
            </Grid>
            <Grid item xs={12}>
                <FormDateTimePicker
                    date={expFiltersState.startDateTime}
                    title="Start date and time after"
                    changeHandler={(newDateTime) =>
                        expFilterDispatch({
                            type: filterActionTypes.setStartDateTime,
                            payload: newDateTime as Date,
                        })
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormDateTimePicker
                    date={expFiltersState.endDateTime}
                    title="End date and time before"
                    changeHandler={(newDateTime) =>
                        expFilterDispatch({
                            type: filterActionTypes.setEndDateTime,
                            payload: newDateTime as Date,
                        })
                    }
                />
            </Grid>
        </Grid>
    )
}
